/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SpaceExternalListQuery
// ====================================================

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_Anonymous_profilePicture {
  path: string;
}

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_Anonymous {
  displayName: string | null;
  permissionType: SitePermissionType | null;
  profilePicture: SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_Anonymous_profilePicture | null;
}

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_User_profilePicture {
  path: string;
}

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_User {
  displayName: string | null;
  permissionType: SitePermissionType | null;
  profilePicture: SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_User_profilePicture | null;
  accountId: string | null;
  email: string | null;
}

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_KnownUser_profilePicture {
  path: string;
}

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_KnownUser {
  displayName: string | null;
  permissionType: SitePermissionType | null;
  profilePicture: SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_KnownUser_profilePicture | null;
  accountId: string | null;
  email: string | null;
}

export type SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes = SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_Anonymous | SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_User | SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes_KnownUser;

export interface SpaceExternalListQuery_space_directAccessExternalCollaborators {
  nodes: (SpaceExternalListQuery_space_directAccessExternalCollaborators_nodes | null)[] | null;
}

export interface SpaceExternalListQuery_space {
  id: string | null;
  externalCollaboratorCount: number;
  name: string | null;
  directAccessExternalCollaborators: SpaceExternalListQuery_space_directAccessExternalCollaborators | null;
}

export interface SpaceExternalListQuery {
  space: SpaceExternalListQuery_space | null;
}

export interface SpaceExternalListQueryVariables {
  spaceKey?: string | null;
  start?: number | null;
  limit?: number | null;
}
